require('./style.less');

var Marionette = require('marionette'),
    _ = require('underscore');

require('chosenBundle');

module.exports = Marionette.ItemView.extend({

    template: require('./template.hbs'),

    initialize: function(options) {

        _.extend( this, {
            userConsultGroups: options.userConsultGroups,
            note: options.note, // maybe break apart apart and just pass the consult groups of the note (though this doesn't hurt)
            onChange: options.onChange,
            renderDisabled: options.renderDisabled
        });

    },

    serializeData: function() {
        return {
            consultGroups: this._getConsultsForSelect(),
            renderDisabled: this.renderDisabled
        };
    },
    onRender: function() {

        // Leave the select element attributes defined in the template,
        // as opposed to using Backbone view attributes which would override others, eg:
        // tagName: 'select' className: 'consult-grp-select'.
        // But in doing so -- remove the empty div and ensure the selectbox is set as the view's el.
        this.unwrap();

        // Set the value of the dropdown from any note consult groups.
        var noteConsultGrps = this.note.getConsultGroups();

        if (noteConsultGrps ) {

            var grpIds = _.map( noteConsultGrps, function(g) {
                return parseInt(g.groupId);
            });

            this.$el.val( grpIds );
        }

        // Disable from DOM info if:
        // * user has no groups to assign,
        // * or: the note is referred but doesn't the user doesn't have access assign any of its referrals

        if (  this.$('option:enabled').length < 2 ) // (there's always an empty one)
            this.$el.attr('disabled', 'disabled');

    },

    // The chosen plugin with image addon must first be called when it's in the the DOM.
    // When called from the noteView, this is triggered in it's onShow function as a hack.
    // A better long-term solution is to use Region's for the NoteView itself.
    onShow: function() {

        this.$el.chosen({
            search_contains: 1,
            width: '100%',
            placeholder_text_multiple: 'Select Groups...',

            /**
             * HACK!: Use image-select chosen add-on template and it's {url} to but a box with the group's color next to it's name
             * Note: this template gets wrapped inside a span.
             * Note: this template won't be applied by the plugin if the url is null (in this case if the color is null),
             * so it's set to transparent inside template logic
             */
            html_template: '<i class="chose-image-group-color-lbl" style="background-color:{url};"></i><span class="chose-note-group-text">{text}</span>'

        }).on('change', _.bind(this.onSelectionChange, this) );


    },
    _getConsultsForSelect: function() {

        // First get all the groups the user can assign (plus an empty one)
        var EMPTY_CONSULT_GRP = {
            groupId: -1,
            name: '',
            color: '',
            userCanAssign: true
        };

        var userConsultGroups = this.userConsultGroups.getArrayOfModelAttrsSortedByName();
        _.each( userConsultGroups, function(g) {
           g['userCanAssign'] = true;
        });

        var groups = [EMPTY_CONSULT_GRP].concat( userConsultGroups );

        // Now deal with any that are assigned to the note but not in the users groups (they can't assign them).
        // Add any that aren't in the user's groups, with a value of userCanAssign = false.

        var noteReferralGroups = this.note.getConsultGroups();

        _.each( noteReferralGroups , function(ng) {

            if ( !_.findWhere( userConsultGroups, {groupId: ng.groupId} ) ) {
                var grpToAdd = _.pick(ng, 'groupId', 'name', 'color');
                grpToAdd['userCanAssign'] = false;
                groups.push( grpToAdd );
            }

        });

        // Hack: already using data-img-src as a hack insert colored 'rectangles' in the image-select template.
        // If this is not defined, the image-select template won't be applied, so make it transparent.
        _.each(groups, function(g) {
            (!g.color) && (g.color ='transparent');
        });

        // TODO: could re-sort by name at end of adding them
        return groups;

    },

    /**
     * Update the 'derived' shape color on the notes UI model ( central point to for a note model ),
     * then call onChange.
     * In the future, if there's a need, probably better to store the selected groups note/noteUI model.
     * Also see overlap when used in F&R when we want to set the note attributes live ...
     */
    onSelectionChange: function() {

        var selectedGroups = this.getSelectedGroups();

        var derivedShapeColor = selectedGroups
            ? this.note.getConsultColorForShapes( selectedGroups )
            : null;

        this.note.uiModel.set( 'currentConsultColorForShapes', derivedShapeColor, {silent: true} );

        this.onChange( selectedGroups, derivedShapeColor );

    },
    // Return array of the group attribute values or null if none are selected
    // Should probably change to use models.
    getSelectedGroups: function() {

        var groups = [];

        // Value on multi-selects doesn't return disabled options ,so use this:
        var aSelectedGrpIds = this.$('option:selected').map( function(i, el) {
           return parseInt(el.value);
        }).get();

        // Pass the selected data from this.consultGroups or noteReferralGroups.
        // Could make easier by using data-attributes on initial output ...

        var noteReferralGroups = this.note.getConsultGroups();

        _.each(aSelectedGrpIds, function(id) {

            var myConsultGroup = this.userConsultGroups.findWhere( {groupId: id});

            if (myConsultGroup) {

                var attrs =  myConsultGroup.toJSON();
                // TODO: temp until group objects are unified on the server or this is accomplished another way
                attrs = _.omit(attrs, 'type', 'groupType', 'description', 'status', 'creationTime', 'email');
                groups.push( attrs );

            } else {
                // get from the noteReferralGroups
                var noteGrp = _.findWhere( noteReferralGroups, {groupId: id} );
                groups.push( noteGrp );
            }

        }, this);

        return groups.length > 0 ? groups : null;

    },
    onBeforeDestroy: function() {
        this.$el
            .off()
            .chosen('destroy');
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/note/consultGroupSelector/view.js
 ** module id = 161
 ** module chunks = 0
 **/